import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpStatus401Component } from './components/http-status401/http-status401.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { StudySelectComponent } from './components/study-select/study-select.component';
import { ModulePermissionGuard } from './guards/module-permission-guard/module-permission-guard';
import * as RoutesConfiguration from './route.constants';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    data: { sidenav: false },
  },
  {
    path: RoutesConfiguration.ROUTE_SITES,
    loadChildren: () => import('../../../cross-study-portal-sites/src/app/app.module').then(module => module.AppModule),
    canLoad: [ModulePermissionGuard],
  },
  {
    path: 'httpstatus401',
    component: HttpStatus401Component,
  },
  {
    path: 'studySelector',
    component: StudySelectComponent,
  },
  {
    path: RoutesConfiguration.ROUTE_ROLES,
    loadChildren: () => import('../../../cross-study-portal-authorization/src/app/app.module').then(module => module.AppModule),
    canLoad: [ModulePermissionGuard],
  },
  {
    path: RoutesConfiguration.ROUTE_GLOBAL_USERS,
    loadChildren: () => import('../../../cross-study-portal-usermanagement-global/src/app/app.module').then(module => module.AppModule),
    canLoad: [ModulePermissionGuard],
  },
  {
    path: RoutesConfiguration.ROUTE_USERS,
    loadChildren: () => import('../../../cross-study-portal-usermanagement/src/app/app.module').then(module => module.AppModule),
    canLoad: [ModulePermissionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
